import request from '@/utils/request';

// 设备报表
export const getPartsStatistics = (params: any) =>
  request({
    url: 'StatisticsParts/Parts',
    method: 'get',
    params
  });

// 导出excel 设备列表
export const exportPartsStatistics = (params: any) =>
  request({
    url: 'StatisticsParts/export',
    method: 'get',
    params
  });
